import React from 'react';

import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import { useTranslation } from 'react-i18next';

export default function SearchValue({ value, onChange }) {
  const { t } = useTranslation();

  return (
    <Input
      value={value}
      onChange={onChange}
      placeholder={t('common.table.filters.search_placeholder')}
      prefix={<SearchOutlined style={{ color: '#bfbfbf' }} />}
      allowClear
      style={{ width: '100%' }}
    />
  );
}
